import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicRechercheEvent = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Utilisez des filtres intuitifs pour dénicher la compétition qui répond à vos attentes. Sélectionnez facilement un event adapté à la taille 
              idéale de votre équipe et correspondant à votre niveau, du scaled à l’elite. 
              Choississez<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>offrant des goodies exclusifs et des 
              cash prizes attractifs par exemple. Affinez votre recherche par région et localisez rapidement le lieu exact de event sur la carte pour planifier 
              votre participation. Voici toutes les options disponibles pour trouver l'event CrossFit parfait.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Que vous recherchiez une compétition dans votre box ou un Throwdown dans une grande ville, vous pouvez trouver votre event parmi des centaines existantes. 
                Il vous suffit de <strong>saisir le nom d'une compétition</strong> dans la barre de recherche. Notre moteur intuifif trouveras ce que vous rechercher.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Il vous suffit de <strong>saisir le nom d'une ville</strong> dans la barre de recherche et vous y verrez toutes les compétitions aux alentours.
              </p>
              <p className="help-text">
                Si vous n’avez pas encore choisi une destination précise et que vous êtes flexible, parcourez rapidement tous les événements sur la carte de France. 
                Accessible via le bouton Filtres, les compétitions sont indiquées par des points rouges. Il vous suffit de cliquer sur une ou plusieurs régions pour 
                afficher uniquement les compétitions disponibles dans ces zones.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{anchorsParts[2].content}</p>
              <p className="help-text">
                Dans la bannière, vous trouverez deux onglets principaux : <strong>En cours et Tout.</strong> L’onglet En cours affiche par défaut toutes les compétitions 
                actuellement actives ou à venir. Quant à l’onglet Tout, comme son nom l’indique, il permet de consulter l’ensemble des compétitions, 
                qu’elles soient passées ou futures. Ces onglets sont essentiels, car le résultat de votre recherche dépend entièrement de votre sélection. 
                <br />Ne les négligez pas pour trouver rapidement les événements qui vous intéressent !
              </p>
              <p className="help-text">
                Si vous recherchez une date précise, utilisez les filtres pour sélectionner un ou plusieurs mois. En quelques clics, vous pourrez afficher uniquement 
                les compétitions correspondant aux plages de dates choisies.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <p className="help-title-part">{anchorsParts[3].content}</p>
              <p className="help-text">
                Depuis la liste de toutes les<a target="_blank" className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>compétitions</a>
                disponibles, vous trouverez sous la bannière des tags de recherche rapide : Indiv, Team 2, Team 3 et bien d’autres. En cliquant sur l’un de ces tags, 
                vous pouvez instantanément filtrer les compétitions pour afficher celles qui correspondent au format sélectionné.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[4].ref}>
              <p className="help-title-part">{anchorsParts[4].content}</p>
              <p className="help-text">
                Voici d'autres fonctionnalités de recherche pour vous aider à trouver les compétitions qui correspondent à vos besoins :
              </p>
              <p className="help-text">
                Si vous avez une idée précise de l’événement que vous recherchez, <strong>cliquez sur Filtres.</strong> Vous pourrez alors combiner plusieurs critères pour 
                affiner votre recherche de manière efficace. Sélectionnez, par exemple, une compétition dans une certaine tranche de prix, avec des tags spécifiques 
                ou un format particulier. Explorez les options disponibles, et laissez libre cours à votre curiosité : ces filtres sont faits pour vous simplifier la vie ! 
              </p>
              <p className="help-text">
                <strong>Favoris :</strong> vous avez trouvé un certain nombre de compétitions que vous aimeriez enregistrer ? 
                Enregistrez-les en favoris afin de pouvoir les retrouver facilement plus tard et même les partager avec vos amis.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicRechercheEvent